import React, { Component } from 'react';
import { connect } from 'react-redux';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import { showNotification as showNotificationAction, refreshView as refreshViewAction } from 'admin-on-rest';
import restClient from '../restClient';

// Default "blacklist clicks from" date: start of the current month. Previous months are
// already invoiced, so a bulk import should never silently reach back into one.
// Plain YYYY-MM-DD (native <input type="date">, not MUI's DatePicker) - a DatePicker's popup
// calendar can render behind an enclosing Dialog due to a z-index stacking conflict, making it
// unusable. See https://github.com/mui/mui-x/issues/10035 for the same class of issue.
const defaultFromDate = () => {
    const now = new Date();
    return `${now.getUTCFullYear()}-${String(now.getUTCMonth() + 1).padStart(2, '0')}-01`;
};

class BulkBlacklistUseragentsButton extends Component {
    state = { dialogOpen: false, loading: false, useragents: '', label: '', removeclicks_from: defaultFromDate() };

    openDialog = () => this.setState({ dialogOpen: true });
    closeDialog = () => this.setState({ dialogOpen: false });

    handleSubmit = () => {
        const { showNotification, refreshView } = this.props;
        const { useragents, label, removeclicks_from } = this.state;

        if (!useragents.trim()) {
            showNotification('Plak eerst één of meer user agents (of stukjes daarvan)', 'warning');
            return;
        }

        this.setState({ loading: true });

        restClient('POST', 'admin/useragent_blacklist_bulk', {
            data: {
                useragents,
                label: label || undefined,
                removeclicks_from,
            },
        })
            .then(({ data }) => {
                showNotification(`${data.created} user agent(s) toegevoegd, ${data.skipped} overgeslagen (al aanwezig)`, 'confirm');
                this.setState({ loading: false, dialogOpen: false, useragents: '', label: '', removeclicks_from: defaultFromDate() });
                refreshView();
            })
            .catch((e) => {
                console.error(e);
                const message = (e && e.message) || 'Bulk-import mislukt, probeer het opnieuw';
                showNotification(message, 'warning');
                this.setState({ loading: false });
            });
    };

    render() {
        const { dialogOpen, loading, useragents, label, removeclicks_from } = this.state;

        const actions = [
            <FlatButton label="Annuleer" onClick={this.closeDialog} disabled={loading} />,
            <RaisedButton
                label={loading ? 'Bezig...' : 'Blacklisten'}
                primary
                style={{ marginLeft: 8 }}
                onClick={this.handleSubmit}
                disabled={loading}
            />,
        ];

        return (
            <span>
                <FlatButton label="Bulk toevoegen" onClick={this.openDialog} />
                <Dialog
                    title="Meerdere user agents tegelijk blacklisten"
                    modal={false}
                    open={dialogOpen}
                    onRequestClose={this.closeDialog}
                    actions={actions}
                    autoScrollBodyContent
                >
                    <p>
                        Eén user agent (of een herkenbaar stukje daarvan, bijv. "Barkrowler") per regel
                        — <strong>niet</strong> scheiden met komma's, user agents bevatten die vaak zelf.
                        Elke regel blokkeert voortaan alle kliks waarvan de user agent die tekst bevat.
                        Kliks vanaf hieronder gekozen datum worden alsnog als ongeldig gemarkeerd. Kies
                        nooit een datum in een al gefactureerde maand — standaard staat dit op de 1e
                        van deze maand.
                    </p>
                    <TextField
                        floatingLabelText="User agents"
                        hintText={'Barkrowler\nadscanner\n...'}
                        multiLine
                        rows={6}
                        fullWidth
                        value={useragents}
                        onChange={(_e, v) => this.setState({ useragents: v })}
                    />
                    <TextField
                        floatingLabelText="Label (optioneel)"
                        hintText="Bijv. 'Analyse juli 2026'"
                        fullWidth
                        value={label}
                        onChange={(_e, v) => this.setState({ label: v })}
                    />
                    <br />
                    <TextField
                        type="date"
                        floatingLabelText="Kliks blacklisten vanaf"
                        fullWidth
                        value={removeclicks_from}
                        onChange={(_e, v) => this.setState({ removeclicks_from: v })}
                    />
                </Dialog>
            </span>
        );
    }
}

export default connect(null, {
    showNotification: showNotificationAction,
    refreshView: refreshViewAction,
})(BulkBlacklistUseragentsButton);



// WEBPACK FOOTER //
// ./src/siteclicks/BulkBlacklistUseragentsButton.js